<template>
    <ui-container class="py-8">
        <ui-header :title="editMode ? 'Editing Fine - #'+this.item.id : 'Create new Fine'" :subtitle="` `">
            <template #actions>
                <ui-button-new icon="fas fa-arrow-left" @click="finished()" v-if="editMode">Back</ui-button-new>
            </template>
        </ui-header>
        <div class="grid gap-6 grid-cols-12 py-6">
            <ui-date-picker label="Date of Fine" name="date" v-model="form.date" class="xl:col-span-6"
                            placeholder="What was the date for this fine?"
                            :error="form.errors.get('date')"
                            @input="save"></ui-date-picker>
            <ui-select-searchable
                class="xl:col-span-6"
                label="Vehicle"
                v-model="form.vehicle"
                :error="form.errors.get('vehicle')"
                :options="vehicles"
                @input="save"
            ></ui-select-searchable>
            <ui-input label="PCN Number" name="pcn_number" v-model="form.pcn_number"
                      placeholder="What is the PCN number?"
                      class="xl:col-span-6" :error="form.errors.get('pcn_number')" @input="save"></ui-input>
            <ui-input label="Amount" name="amount" v-model="form.amount"
                      placeholder="What is the fine/charge value in pounds and pence?"
                      class="xl:col-span-6" :error="form.errors.get('amount')" @input="save"></ui-input>
            <ui-select-searchable
                class="xl:col-span-6"
                label="Driver"
                v-model="form.driver"
                :error="form.errors.get('driver_id')"
                :search="searchContact"
                @input="save"
            ></ui-select-searchable>
            <ui-input label="Fine Authority" name="fine_auth" v-model="form.fine_auth"
                      placeholder="What is the fining Authority?"
                      class="xl:col-span-6" :error="form.errors.get('fine_auth')" @input="save"></ui-input>
            <ui-select-searchable
                class="xl:col-span-12"
                label="Package"
                v-model="form.package"
                :search="searchPackages"
                @input="save"
            ></ui-select-searchable>
            <ui-textarea autoresize label="Offense" name="offense" v-model="form.offense"
                         placeholder="Enter the details of the offense..."
                         class="xl:col-span-12" :error="form.errors.get('offense')" @input="save"></ui-textarea>
            <ui-textarea autoresize label="Status" name="status" v-model="form.status"
                         placeholder="Enter any status updates..."
                         class="xl:col-span-12" :error="form.errors.get('status')" @input="save"></ui-textarea>
        </div>

        <ui-data-grid-item wide class="mt-6 flex" v-if="!editMode">
            <div class="flex flex-col md:flex-row justify-end flex-wrap">
                <ui-button-new v-if="editMode" @click="edit(false)" class="ml-3">Cancel</ui-button-new>
                <ui-button-new primary @click.prevent="form.submit()" :loading="form.busy" class="ml-3">Create
                </ui-button-new>
            </div>
        </ui-data-grid-item>

    </ui-container>
</template>

<script>
import {Contact, Fine, Package} from '@models';
import UiButtonNew from "../ui/UiButtonNew.vue";
import UiInput from "../ui/UiInput.vue";
import UiDataGridItem from "../ui/UiDataGridItem.vue";
import UiDatePicker from "../ui/UiDatePicker.vue";
import UiContainer from "../ui/UiContainer.vue";
import UiHeader from "../ui/UiHeader.vue";

export default {
    components: {
        UiHeader,
        UiContainer,
        UiDatePicker,
        UiDataGridItem,
        UiInput,
        UiButtonNew

    },
    props: {
        item: Object,
        edit: Function,
        addItem: Function,
        vehicles: Array,
    },
    data() {
        const initialData = this.item
            ? this.item.getFormAttributes()
            : {}
        return {
            form: new Form(initialData, async (form) => {
                let data = form.export();
                let sorter = (items) => {
                    items.sort((a, b) => (a.date < b.date) ? 1 : ((b.date < a.date) ? -1 : 0));
                };
                if (this.editMode) {
                    await this.item.update(data)
                    this.edit(true, sorter)
                } else {
                    const newFine = await Fine.create(data)

                    this.addItem(newFine, 0, sorter);
                    form.reset()
                }
            }),
        }
    },
    methods: {
        save() {
            if (this.editMode) {
                this.form.submit()
            }
        },
        finished() {
            let sorter = (items) => {
                items.sort((a, b) => (a.date < b.date) ? 1 : ((b.date < a.date) ? -1 : 0));
            };
            this.edit(false, sorter)
        },
        async searchContact(query) {
            return (await Contact.search(query)).map(x => x.toDropdown())
        },
        async searchPackages(query) {
            return await Package.search(query, true)
        },

    },
    computed: {
        editMode() {
            return !!this.item
        },
    },
}
</script>
